import SearchableMultiSelect from './SearchableMultiSelect'

export default SearchableMultiSelect
